function Footer(props) {
    return(
        <div className="u-full-width">
            <h3>Copyright © Fish Problems 2022</h3>
        </div>
    )
}
export default Footer